import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadset, faDisplay } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import './BottomContactBar.css';

const BottomContactBar = ({ onContactClick }) => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const section = document.getElementById('contato');
    if (!section) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setHidden(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      className={`bottom-contactbar${hidden ? ' bottom-contactbar--hidden' : ''}`}
      role="complementary"
      aria-label="Atalhos de contato"
    >
      <div className="bottom-contactbar__inner">
        <div className="bottom-contactbar__content">
          <div className="bottom-contactbar__actions">
            <a
              className="bottom-contactbar__action bottom-contactbar__action--suporte"
              href="https://wa.me/554632250131"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faHeadset} />
              <span>Suporte Técnico</span>
            </a>

            <span className="bottom-contactbar__divider" aria-hidden="true" />

            <button
              type="button"
              className="bottom-contactbar__action bottom-contactbar__action--cta"
              onClick={onContactClick}
            >
              <FontAwesomeIcon icon={faDisplay} />
              <span>Solicite uma demonstração grátis</span>
            </button>

            <span className="bottom-contactbar__divider" aria-hidden="true" />

            <a
              className="bottom-contactbar__action bottom-contactbar__action--whatsapp"
              href="https://wa.me/5546991107619"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faWhatsapp} />
              <span>Fale com um especialista</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

BottomContactBar.propTypes = {
  onContactClick: PropTypes.func.isRequired,
};

export default BottomContactBar;
